import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Login = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 8.878C11.4996 8.9447 11.4861 9.00831 11.4621 9.06639C11.4377 9.12536 11.4015 9.18062 11.3536 9.22855L8.85355 11.7286C8.65829 11.9238 8.34171 11.9238 8.14645 11.7286C7.95118 11.5333 7.95118 11.2167 8.14645 11.0214L9.79289 9.375L2 9.375C1.72386 9.375 1.5 9.15114 1.5 8.875C1.5 8.59886 1.72386 8.375 2 8.375L9.79289 8.375L8.14645 6.72855C7.95118 6.53329 7.95118 6.21671 8.14645 6.02145C8.34171 5.82618 8.65829 5.82618 8.85355 6.02145L11.3536 8.52145C11.4504 8.61832 11.4992 8.74504 11.5 8.872L11.5 8.875L11.5 8.878ZM6 14.375C5.72386 14.375 5.5 14.5989 5.5 14.875C5.5 15.1511 5.72386 15.375 6 15.375L14 15.375C14.2761 15.375 14.5 15.1511 14.5 14.875L14.5 2.875C14.5 2.59886 14.2761 2.375 14 2.375L6 2.375C5.72386 2.375 5.5 2.59886 5.5 2.875C5.5 3.15114 5.72386 3.375 6 3.375L13.5 3.375L13.5 14.375L6 14.375Z"
        fill={color}
      />
    </svg>
  )
})

export default Login
